import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Download, X } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { tx } from '@/translations/translations';

const InstallBanner = () => {
  const { language } = useLanguage();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('pwa-install-dismissed');
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    sessionStorage.setItem('pwa-install-dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 bg-slate-900 border border-cyan-500/30 rounded-xl p-4 shadow-2xl z-50 animate-in slide-in-from-bottom-4" data-testid="install-banner">
      <div className="flex items-start gap-3">
        <div className="bg-cyan-500/20 rounded-lg p-2 flex-shrink-0">
          <Download className="h-5 w-5 text-cyan-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white font-semibold text-sm">
            {tx(language, 'Instala Mitzva Fit', 'Install Mitzva Fit', 'התקינו את Mitzva Fit')}
          </p>
          <p className="text-slate-400 text-xs mt-0.5">
            {tx(language, 'Agrega la app a tu pantalla de inicio', 'Add the app to your home screen', 'הוסיפו את האפליקציה למסך הבית')}
          </p>
          <Button
            size="sm"
            className="mt-2 bg-cyan-600 hover:bg-cyan-700 text-xs h-8"
            onClick={handleInstall}
            data-testid="install-btn"
          >
            <Download className="h-3 w-3 mr-1" />
            {tx(language, 'Instalar', 'Install', 'התקנה')}
          </Button>
        </div>
        <button onClick={handleDismiss} className="text-slate-500 hover:text-white" data-testid="install-dismiss-btn">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallBanner;
